import {Component, Input, OnInit} from '@angular/core';
import {Product} from "../../../common/interfaces/Product";

@Component({
  selector: 'product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.scss']
})
export class ProductItemComponent implements OnInit {

  @Input() product!: Product
  imageSrc = ""

  ngOnInit(): void {
      this.imageSrc = this.product.thumbnailURL ?? ''
  }

  setDefaultPlaceholder() {
    this.imageSrc = "assets/product-placeholder.svg"
  }
}
